import currency from 'currency.js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Shanghai');
export function formatNumber(n) {
  return currency(n, {
    separator: ',',
    symbol: ''
  }).format();
}
export function formatCreatedAt(n, isUnix = false, tmp = 'YYYY-MM-DD HH:mm:ss') {
  if (isUnix) {
    return dayjs.unix(n).tz().format(tmp);
  }

  return dayjs.unix(n / 1000000000).tz().format(tmp);
}
export function strToUnix(date) {
  return dayjs(date).tz().unix();
}
export function currentDay() {
  return dayjs().tz().format('YYYY-MM-DD');
}
export function strToDayUnix(date) {
  return dayjs(date).tz().startOf('day').unix();
}
export function dateFromUnix(unix) {
  return dayjs.unix(unix);
}